import { AddressFieldType } from '.';

export const CLASS_NAMES = {
  title: 'text-14-22-em text-neutral-800',
  container: 'flex flex-col',
  header: 'flex flex-row mb-2',
};

export const TITLES: Record<AddressFieldType, string> = {
  current: 'Current Address',
  previous1: 'Previous Address',
  previous2: 'Previous Address 2',
};
